class URL {
    static parameters() {
        const queryString = window.location.search;
        return new URLSearchParams(queryString);
    }
}
export default URL;
